import { createSlice } from "@reduxjs/toolkit";
import { ItemState } from "../../utils/interfaces/packages";

const initialState = {
  bundleProducts: {
    items: [] as Array<ItemState>,
    total_count: 0,
  },
  virtualProducts: {
    items: [] as Array<ItemState>,
    total_count: 0,
  },
};

export const packageSlice = createSlice({
  name: "packages",
  initialState,
  reducers: {
    setBundlePackages: (state, action) => {
      state.bundleProducts = action.payload;
    },
    setVirtualPackages: (state, action) => {
      state.virtualProducts = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setBundlePackages, setVirtualPackages } = packageSlice.actions;

export default packageSlice.reducer;
